module.exports = __webpack_public_path__ + "img/screenshot (5).94fd4e73.jpg";